import { render } from "./SuccessModal.vue?vue&type=template&id=579ab47c&scoped=true&ts=true"
import script from "./SuccessModal.vue?vue&type=script&lang=ts"
export * from "./SuccessModal.vue?vue&type=script&lang=ts"

import "./SuccessModal.vue?vue&type=style&index=0&id=579ab47c&scoped=true&lang=scss"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579ab47c"]])

export default __exports__